export const relatoriosCicloOpcao = { id: 'relatorios-ciclo', title: 'Relatórios do Ciclo' };

export function podeAcessarRelatoriosCiclo(config, groupsConfig, user, banco) {
  if (!String(banco || '').startsWith('selo-') || !config || !config.relatoriosCicloSelo) return false;
  if (user && String(user.email || '').trim().toLowerCase() === 'admin@admin.com.br') return true;
  const grupo = user && user.grupo;
  if (!grupo || grupo.desabilitar || !user.habilitado || !groupsConfig || !groupsConfig.relatoriosCicloSelo) return false;
  try {
    const selecao = Array.isArray(grupo.relatorioAdm) ? grupo.relatorioAdm : JSON.parse(grupo.relatorioAdm || '[]');
    return Array.isArray(selecao) && selecao.includes(relatoriosCicloOpcao.id);
  } catch (_) { return false; }
}

export function filtrarRelatoriosCiclo(items, { regional, sala, categoria }) {
  return items.filter(item => (!regional || item.regional === regional) &&
    (!sala || String(item.municipioId) === String(sala)) && (!categoria || item.categoria === categoria));
}
